import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

@Injectable({
	providedIn: 'root'
})
export class ExportExcelService {
	columnWidth = 25;

	exportExcel(columns: any, data: any, title: string, header?: any[]) {
		const workbook = new Workbook();
		let worksheetHeader: any;

		if (header && Array.isArray(header) && header.length > 0) {
			worksheetHeader = workbook.addWorksheet('Encabezado');
			worksheetHeader.properties.defaultColWidth = this.columnWidth;
			header.forEach((item: any, index: number) => {
				const headers = [
					'Empresa:',
					'Tipo Sucursal:',
					'Sucursal:',
					'Producto:',
					'Campaña:',
					'Stock Total:'
				];

				if (index > 0) {
					worksheetHeader.addRow([]);
				}

				const keyCell = worksheetHeader.getCell(`A${index + 1}`);
				const valueCell = worksheetHeader.getCell(`B${index + 1}`);

				/** Adding header style */
				if (headers.includes(item.key)) {
					keyCell.font = { bold: true, color: { argb: 'ffffff' } };
					keyCell.fill = {
						type: 'pattern',
						pattern: 'solid',
						fgColor: { argb: '2f5927' }
					};
				}

				/** Setting values */
				keyCell.value = item.key;
				valueCell.value = item.value;
			});
			const worksheet = workbook.addWorksheet(title);

			worksheet.columns = columns;
			worksheet.properties.defaultColWidth, worksheet.addRows(data, 'n');
			worksheet.getRow(1).font = { bold: true, color: { argb: 'ffffff' } };
			worksheet.getRow(1).eachCell({ includeEmpty: false }, function (cell) {
				worksheet.getCell(cell.address).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: '2f5927' }
				};
			});
		} else {
			const worksheet = workbook.addWorksheet(title);

			worksheet.columns = columns;
			worksheet.properties.defaultColWidth, worksheet.addRows(data, 'n');
			worksheet.getRow(1).font = { bold: true, color: { argb: 'ffffff' } };
			worksheet.getRow(1).eachCell({ includeEmpty: false }, function (cell) {
				worksheet.getCell(cell.address).fill = {
					type: 'pattern',
					pattern: 'solid',
					fgColor: { argb: '2f5927' }
				};
			});
		}

		workbook.xlsx.writeBuffer().then(data => {
			const blob = new Blob([data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			fs.saveAs(blob, `${title}.xlsx`);
		});
	}
}
